<div #notificationsRef class="cmx-notifications" *ngIf="version !== 3">
  <div
    class="cmx-notifications__toggle"
    role="button"
    [attr.aria-pressed]="isNotificationsOpen"
    (click)="toggleNotifications()"
  >
    <ng-container *ngIf="notificationsService.notificationsCount | async as count">
      <span *ngIf="count > 0" class="cmx-notifications__count">{{
        notificationsService.notificationsCount | async
      }}</span>
    </ng-container>
    <svg
      xml:space="preserve"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      height="30px"
      id="Capa_1"
      style="enable-background:new 0 0 512 512;"
      version="1.1"
      viewBox="0 0 512 512"
      width="30px"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g _ngcontent-c9="">
        <g _ngcontent-c9="">
          <g _ngcontent-c9="">
            <path
              _ngcontent-c9=""
              class="active-path"
              d="M467.812,431.851l-36.629-61.056c-16.917-28.181-25.856-60.459-25.856-93.312V224c0-67.52-45.056-124.629-106.667-143.04    V42.667C298.66,19.136,279.524,0,255.993,0s-42.667,19.136-42.667,42.667V80.96C151.716,99.371,106.66,156.48,106.66,224v53.483    c0,32.853-8.939,65.109-25.835,93.291l-36.629,61.056c-1.984,3.307-2.027,7.403-0.128,10.752c1.899,3.349,5.419,5.419,9.259,5.419    H458.66c3.84,0,7.381-2.069,9.28-5.397C469.839,439.275,469.775,435.136,467.812,431.851z"
              data-old_color="#000000"
              data-original="#000000"
              fill="#FFFFFF"
            ></path>
          </g>
        </g>
        <g _ngcontent-c9="">
          <g _ngcontent-c9="">
            <path
              _ngcontent-c9=""
              class="active-path"
              d="M188.815,469.333C200.847,494.464,226.319,512,255.993,512s55.147-17.536,67.179-42.667H188.815z"
              data-old_color="#000000"
              data-original="#000000"
              fill="#FFFFFF"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="cmx-notifications__content-wrap"
    [class.cmx-notifications__content-wrap--rtl]="direction === 'rtl'"
    *ngIf="isNotificationsOpen"
  >
    <div class="cmx-notifications-content" [class.cmx-notifications-content--rtl]="direction === 'rtl'">
      <ng-container *ngIf="notificationsService.notifications | async as notifications">
        <div *ngIf="!(notifications.length > 0)" class="cmx-notifications-unavailable">
          {{ notificationsService.notificationsUnavailableLabel | async }}
        </div>
        <div *ngIf="notifications.length > 0" class="cmx-notifications-list">
          <div
            *ngFor="let notification of notifications"
            class="cmx-notifications-item"
            [class.cmx-notifications-item--unseen]="notification.kind === 'unseen'"
            (click)="notificationItemClick(notification)"
          >
            <i *ngIf="notification.icon" class="cmx-notifications-item__icon" [ngClass]="[notification.icon]"></i>
            <div class="cmx-notifications-item__content">
              <div class="cmx-notifications-item__muted">
                <span class="cmx-notifications-item__category">{{ notification.categoryName }}</span>
                <span class="cmx-notifications-item__date">{{ notification.dateTime }}</span>
              </div>
              <div class="cmx-notifications-item__message">{{ notification.message }}</div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="cmx-notifications-content__view-all" role="button" (click)="viewAllNotifications()">
        {{ notificationsService.notificationsViewAllLabel | async }}
      </div>
    </div>
  </div>
</div>

<div class="cmx-nav-header__section-item" *ngIf="version === 3">
  <span class="cmx-nav-header__icon-alert" *ngIf="countNotifications"></span>
  <!-- notifications -->
  <cwc-popover #notificationsPopover>
    <cwc-button
      [tittle]="notificationsService.notificationsLabel | async"
      slot="target"
      variant="link"
      white
      id="userNotificationsPopoutButton"
      (click)="toggleNotifications()"
    >
      <span class="cmx-nav-header__icon cmx-nav-header__icon--notifications">
        <cwc-icon
          name="notification"
          [color]="variant === 'negative' ? 'true-blue' : 'true-white'"
          size="1.5rem"
        ></cwc-icon>
      </span>
    </cwc-button>
    <div slot="content" class="cmx-nav-header__notifications-popover" id="userNotificationsPopout">
      <div *ngIf="renderNotificacionsContent">
        <div class="cmx-nav-header__notifications-loading" *ngIf="notificationsService.userNotificationLoading | async">
          <cwc-loader size="medium">
            <span slot="loading">{{ notificationsService.notificationsLoadingLabel | async }}</span>
            <span slot="delay">{{ notificationsService.notificationsDelayLabel | async }}</span>
            <span slot="error">
              {{ (notificationsService.notificationsErrorLabel | async) + ' ' }}
              <a href="#" (click)="reload()">
                {{ notificationsService.notificationsErrorLinkRefresh | async }}
              </a>
            </span>
          </cwc-loader>
        </div>
        <div
          class="cmx-nav-header__notifications-empty"
          *ngIf="!(notificationsService.userNotificationLoading | async) && countNotifications === 0"
          (click)="viewAllNotifications()"
        >
          <cwc-icon-animated variant="informative" size="80"></cwc-icon-animated>
          {{ notificationsService.notificationsUnavailableLabel | async }}
        </div>
        <div
          class="cmx-nav-header__notifications-list"
          *ngIf="
            !(notificationsService.userNotificationLoading | async) &&
            (notificationsService.notifications | async) as notifications
          "
        >
          <h3 class="cmx-nav-header__notifications-heading">
            {{ notificationsService.notificationsLabel | async }}
          </h3>
          <div
            *ngFor="let notification of notificationsService.notifications | async; index as i"
            id="userNotificationEntry{{ i }}"
            class="{{
              'cmx-nav-header__notifications-entry cmx-nav-header__notifications-entry--' + notification.statusCode
            }}"
            (click)="notificationItemClick(notification)"
            [ngClass]="{
              'cmx-nav-header__notifications-entry--new': notification.kind === 'unseen',
              'cmx-nav-header__notifications-entry--seen': notification.kind === 'seen',
              'cmx-nav-header__notifications-entry--read': notification.kind === 'read'
            }"
            role="button"
          >
            <div class="cmx-nav-header__notifications-entry-icon">
              <cwc-icon
                *ngIf="notification.icon"
                size="24px"
                [name]="notification.icon?.replace('cmx-icon-', '')"
              ></cwc-icon>
            </div>
            <div class="cmx-nav-header__notifications-entry-body">
              <div class="cmx-nav-header__notifications-entry-process">{{ notification.categoryName }}</div>
              <div class="cmx-nav-header__notifications-entry-description">{{ notification.message }}</div>
              <div class="cmx-nav-header__notifications-entry-date">
                {{ notification.dateTime }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="cmx-nav-header__notifications-footer"
          *ngIf="!(notificationsService.userNotificationLoading | async) && countNotifications > 0"
        >
          <cwc-button variant="link" (cwcClick)="viewAllNotifications()">
            {{ notificationsService.notificationsViewAllLabel | async }}
          </cwc-button>
        </div>
      </div>
    </div>
  </cwc-popover>
</div>
